import React from "react";
import styles from "./Client.module.scss";
import { AiFillEdit, AiOutlineDelete, AiOutlineUser } from "react-icons/ai";
import StatsItem from "../Dashboard/StatsItem";
import CustomersAiTable from "../../../components/Tables/CustomersAiTable/CustomersAitTable";

const Client = () => {
  return (
    <div className={styles.clientPage}>
      <h1 className={styles.clientTitle}>Пользователь</h1>
      <div className={styles.clientContainer}>
        <div className={styles.profileHeader}>
          <div className={styles.headerLeft}>
            <AiOutlineUser size={32} fill="#545152" />
            <div>Vova Myrosh</div>
            <div className={styles.headerStatus}>Active</div>
          </div>

          <button>
            <AiOutlineDelete fill="red" size={32} />
          </button>
        </div>
        <div className={styles.clientStats}>
          <StatsItem title="Запросов" />
          <StatsItem title="Запросов" date="за 7 дней" />
          <StatsItem title="Сотрудников" />
        </div>
        <h2>Основная информация:</h2>

        <div className={styles.clientInfo}>
          <div className={styles.clientInfoItem}>
            Дата регистрации :{" "}
            <span className={styles.itemContent}>22/03/2025</span>
          </div>
          <div className={styles.clientInfoItem}>
            Последний вход :
            <span className={styles.itemContent}>25/03/2025</span>
          </div>
          <div className={styles.clientInfoItem}>
            Email : <span className={styles.itemContent}>123@gmail.com</span>{" "}
            <AiFillEdit size={18} />
          </div>
          <div className={styles.clientInfoItem}>
            Тариф : <span className={styles.itemContent}>Пробный</span>{" "}
            <AiFillEdit size={18} />
          </div>
        </div>
        <h2>AI-ассистенты пользователя:</h2>
        <div>
          <CustomersAiTable />
        </div>
      </div>
    </div>
  );
};

export default Client;
